import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAppId } from '../context/AppIdContext';

const PracharButton = ({ voter }) => {
    // ✅ ADDED prachar state from context
    const { language, prachar } = useAppId();
    const navigate = useNavigate();
    const lang = language || 'en';

    console.log(prachar);

    // ✅ NEW CONDITION: જો prachar "1" ન હોય તો કઈ જ નહિ બતાવે (Hide Button)
    if (Number(prachar) !== 1) {
        return null;
    }

    const t = {
        en: { prachar: "Prachar" },
        hi: { prachar: "प्रचार" },
        gu: { prachar: "પ્રચાર" }
    };
    const txt = t[lang] || t.en;

    const handlePrachar = (e) => {
        if (e) e.stopPropagation();
        if (!voter) return;

        navigate('/prachar', {
            state: {
                voter_id: voter.idcard_no,
                contact_no: voter.contact_no || voter.mobile_no
            }
        });
    };

    return (
        <button
            onClick={handlePrachar}
            className="action-btn-wrapper"
            style={{
                textDecoration: 'none',
                background: 'none',
                border: 'none',
                cursor: 'pointer',
                padding: 0
            }}
        >
            <div className="circle-btn" style={{ backgroundColor: '#ef4444' }}>
                👤
            </div>
            <span className="btn-label">{txt.prachar}</span>
        </button>
    );
};

export default PracharButton;